import { Link } from "react-router-dom";
import type { Episode } from "@/types";

interface EpisodeCardProps {
  episode: Episode;
}

export default function EpisodeCard({ episode }: EpisodeCardProps) {
  return (
    <Link
      to={`/episode/${episode.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={episode.cover}
          alt={`年轻的母亲 第${episode.number}集 ${episode.title} 剧照`}
          title={`年轻的母亲 第${episode.number}集 ${episode.title}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium font-label">
          第{episode.number}集
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/60 text-background-50 text-xs font-label">
          {episode.duration}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center justify-center w-9 h-9 rounded-full bg-background-50/90 text-primary-600 opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
          <i className="ri-play-fill text-lg"></i>
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-medium text-sm md:text-base text-foreground-950 leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
          第{episode.number}集 · {episode.title}
        </h3>
        <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {episode.summary}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-400 font-label">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {episode.airDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-400"></i>
            {episode.views}
          </span>
        </div>
      </div>
    </Link>
  );
}